import { createResource, type RouteResource } from 'react-resource-router';

import type { CustomRolesListResponse } from '../../common/types';
import { getCustomRolesListEndpoint } from '../custom-role/endpoints';

export const customRolesResource: RouteResource<CustomRolesListResponse> = createResource({
	type: 'rolesResource',
	getKey: () => 'rolesResource',
	getData: getCustomRolesListEndpoint,
	isBrowserOnly: true,
});

export const resources = (): RouteResource<CustomRolesListResponse>[] => [customRolesResource];
